import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import FormGroup from "features/shared/forms/components/FormGroup";
import { useTranslation } from "react-i18next";
import {
  getDynamicFieldBlurHandler,
  getTranslatedText,
  getTranslatedTooltip,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";

const TextAreaField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const { bindFieldNew, errors, validateFormField } = { ...formHandler };

  // render
  return (
    <div className={descriptor.className}>
      <FormGroup
        labelText={getTranslatedText(descriptor, "label", t)}
        validationError={errors ? errors[descriptor.name] : undefined}
        tooltip={getTranslatedTooltip(descriptor, t)}
      >
        <textarea
          id={descriptor.name}
          className="form-control"
          rows={5}
          placeholder={getTranslatedText(descriptor, "placeholder", t)}
          onBlur={getDynamicFieldBlurHandler(descriptor, validateFormField)}
          {...bindFieldNew(descriptor.name)}
        />
      </FormGroup>
    </div>
  );
};

export default TextAreaField;
